import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, signInWithCustomTokenAuth } from "../config";

export const sendAuthToken = createAsyncThunk(
  "onboarding/sendAuthToken",
  async (_, { getState, rejectWithValue }) => {
    const { authCode } = getState();
    try {
      const result = await api.userSendAuthCode({ id: authCode.accountID });
      return result.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const authenticateCode = createAsyncThunk(
  "onboarding/authenticateCode",
  async (_, { getState, rejectWithValue }) => {
    const { authCode } = getState();
    try {
      const result = await api.userAuthenticateCode({ code: authCode.code, sessionId: authCode.sessionID });
      
      if (result.data?.data?.token) {
        
        await signInWithCustomTokenAuth(result.data?.data?.token);

        return;
        
      } else {
        throw new Error(result.data?.error || 'Authentication failed');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const authCodeSlice = createSlice({
    name: "authCode",
    initialState: {
        accountID: null,
        sessionID: null,
        code: '',
        error: null,
        processing: false,
        sent: false,
        timestamp: null,
        validated: false,
        authenticated: false,
        
    },
    reducers: {
      setAccountID: (state, action) => {
        state.accountID = action.payload;
      },
      setCode: (state, action) => {
        state.code = action.payload;
      },
      setCodeSent: (state, action) => {
        state.sent = action.payload;
      },
      setError: (state, action) => {
        state.error = action.payload;
      },
    },
    extraReducers: {
      [sendAuthToken.pending]: (state) => {
        state.authenticated = false;
        state.sent = false;
        state.authenticated = false;
        state.timestamp = null;
        state.processing = true;
        state.error = null;
      },
      [sendAuthToken.fulfilled]: (state, action) => {
        state.processing = false;
        state.sessionID = action.payload.id;
        state.timestamp = action.payload.data.timestamp;
        state.sent = true;
      },
      [sendAuthToken.rejected]: (state, action) => {
        state.processing = false;
        state.error = action.payload;
      },
      [authenticateCode.pending]: (state) => {
        state.processing = true;
        state.error = null;
      },
      [authenticateCode.fulfilled]: (state,action) => {
        state.processing = false;
        state.authenticated = true;
      },
      [authenticateCode.rejected]: (state, action) => {
        state.processing = false;
        state.error = action.payload;
      }
    },
  });
  
  export const {
    setAccountID,
    setCode,
    setCodeSent,
    setAuthenticated,
    setTimestamp
  } = authCodeSlice.actions;
  
  export default authCodeSlice.reducer;